
import {collection, getDocs} from 'firebase/firestore';
import {db} from '../firebase';


import { Halo } from "../globalValues";

export default async function getHaloWallpapers() {
    try {
        const tempList: Halo[] = [];

        const haloWall = await getDocs(collection(db, "Halo-Infinite-Wallpapers"));

        haloWall.forEach(doc => {
            const temp = {
                id: doc.id,
                url: doc.data().url,
                season: doc.data().season,
                thumbnail: doc.data().thumbnail
            }
            tempList.push(temp);
        });
        

        tempList.sort(function(a, b) { 
            var textA = parseInt(a.season);
            var textB = parseInt(b.season);
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
        
        const d = new Date();
        window.sessionStorage.setItem("listofWallpapers-Halo", JSON.stringify(tempList));
        localStorage.setItem("Last-Fetch-Time-Halo", JSON.stringify(d.getTime()));

        
        return tempList;
    }
    catch(e) {
        console.log(e);
    }    
}

